/*
    Used for injecting global dependencies without wasting data from load
    TODO Implement
 */

const resolveModule = (...names) => fallbackImport => {
    for (let i = 0; i < names.length; i++) {
        const name = names[i];
        if (window[name]) {
            return window[name];
        }
    }

    // Import fallback and cache it to window object
    const fallback = import(fallbackImport);
    window[names[0]] = fallback;

    return fallback;
};

const module = {
    /** @returns jQuery */
    $: () => resolveModule('$', 'jQuery')('jquery'),
};

export default module;
